import * as actionTypes from "../actionTypes";
export const generateIdeas = (payload) => ({
    type: actionTypes.SET_GENERATE_IDEAS,
    data: payload
});

export const generateIdeasSuccess = (payload) => ({
    type: actionTypes.SET_GENERATE_IDEAS_SUCCESS,
    payload: payload
});
export const generateIdeasError = () => ({
    type: actionTypes.SET_GENERATE_IDEAS_ERROR,
});
export const generateIdeasStreamStart = () => ({
    type: actionTypes.SET_GENERATE_IDEAS_STREAM_START,
});
export const generateIdeasStreamDelta = (payload) => ({
    type: actionTypes.SET_GENERATE_IDEAS_STREAM_DELTA,
    payload,
});
export const generateIdeasStreamDone = () => ({
    type: actionTypes.SET_GENERATE_IDEAS_STREAM_DONE,
});
export const generateIdeasStreamError = (payload) => ({
    type: actionTypes.SET_GENERATE_IDEAS_STREAM_ERROR,
    payload,
});

export const initGetTerms = (payload) => ({
    type: actionTypes.INIT_GET_TERMS,
    data: payload || {},
});
export const getTerms = () => ({
    type: actionTypes.GET_TERMS,
});
export const getTermsSuccess = (payload) => ({
    type: actionTypes.GET_TERMS_SUCCESS,
    payload: payload
});
export const getTermsError = () => ({
    type: actionTypes.GET_TERMS_ERROR,
});

export const initStartActionPlan = () => ({
    type: actionTypes.INIT_START_ACTION_PLAN,
});
export const startActionPlan = () => ({
    type: actionTypes.START_ACTION_PLAN,
});
export const startActionPlanSuccess = () => ({
    type: actionTypes.START_ACTION_PLAN_SUCCESS,
});
export const startActionPlanError = (payload) => ({
    type: actionTypes.START_ACTION_PLAN_ERROR,
    payload,
});

export const setTerms = (payload, id, clientId) => ({
    type: actionTypes.SET_TERMS,
    payload: payload,
    id: id || null,
    clientId: clientId || null
});
export const setTermsSuccess = (payload) => ({
    type: actionTypes.SET_TERMS_SUCCESS,
    payload: payload
});

export const setTermsError = () => ({
    type: actionTypes.SET_TERMS_ERROR,
});

export const deleteTerms = (id) => ({
    type: actionTypes.DELETE_TERMS,
    id: id
});

export const deleteTermsSuccess = () => ({
    type: actionTypes.DELETE_TERMS_SUCCESS,
});

export const deleteTermsError = () => ({
    type: actionTypes.DELETE_TERMS_ERROR,
});


export const downloadAction = (id) => ({
    type: actionTypes.DOWNLOAD_ACTION,
    id: id
});

export const downloadActionSuccess = () => ({
    type: actionTypes.DOWNLOAD_ACTION_SUCCESS,
});

export const downloadActionError = () => ({
    type: actionTypes.DOWNLOAD_ACTION_ERROR,
});


export const reorderActionTerm = (payload) => ({
    type: actionTypes.REORDER_ACTION_TERM,
    payload: payload
});

export const reorderActionTermSuccess = () => ({
    type: actionTypes.REORDER_ACTION_TERM_SUCCESS,
});

export const reorderActionTermError = () => ({
    type: actionTypes.REORDER_ACTION_TERM_ERROR,
});
